import Stars from "./Stars";
import "./ProCon.css";

const ProCon = () => (
    <Stars isMoving={true}>
        <main className="proconContent">
            <h1>Pro/Con Battle</h1>

            <section>
                <h2>Privacy policy</h2>
                <p>
                    Pro/Con Battle does not collect, transmit, sell, or share personal information.
                    Your decisions, options, pros, and cons are stored only on your device.
                </p>
            </section>

            <section>
                <h2>Support</h2>
                <p>For support, email renepot@proton.me.</p>
            </section>
        </main>
    </Stars>
);

export default ProCon;
